
export const threeDs = "3ds";

export const wallet = "wallet";

export const cvv = "cvv";

export const tokenize = "tokenize";

export const sessionId = "sessionId";